// extracted by css-extract-rspack-plugin
export default {"BranchInfoBarContainer":"BranchInfoBar-module__BranchInfoBarContainer__xZHyz","branchInfoBarBase":"BranchInfoBar-module__branchInfoBarBase__drYtr"};